
<div :id="uid" class="notification-container">
  <div
    v-if="afficherNotification"
    class="overlay-contenu-connexe"
    :class="[jel_getClassObject(content), content.theme, { active: isActive }]"
    :style="{
      '--largeur': content.typeNotification.largeur + 'px',
      '--hauteur': content.typeNotification.hauteur + 'px',
    }"
    :data-component-gacategory="content.googleAnalytics?.eventCategory"
    :data-component-gaaction="content.googleAnalytics?.eventAction"
    :data-component-galabel="content.googleAnalytics?.eventLabel"
  >
    <span class="btn-close text-center" @click="fermerNotification()">x</span>
    <MediaVideo v-if="content.typeNotification.field == 'video'" :content="contentMediaVideo" />
    <b-link
      v-else-if="content.typeNotification.field == 'image'"
      class="d-flex justify-content-center align-items-center"
      :class="{ 'img-only': content.typeNotification.notes }"
      v-bind="jel_getLienBinding(content.typeNotification.lien)"
    >
      <div :class="content.typeNotification.notes ? 'w-50 pr-1' : 'w-100'">
        <img
          :ga-img-name="content.typeNotification.image['@name']"
          :src="jel_getFichierSrc(content.typeNotification.image)"
          :alt="content.typeNotification.imageAlt"
          class="w-100"
        />
      </div>
      <div
        v-if="content.typeNotification.notes"
        class="justify-content-center"
        :class="{ 'w-50 pl-1': content.typeNotification.image }"
      >
        <div>
          <strong v-if="content.typeNotification.title">{{
            content.typeNotification.title
          }}</strong>
        </div>
        <div
          v-if="content.typeNotification.notes"
          class="note"
          v-html="content.typeNotification.notes"
        />
      </div>
    </b-link>
  </div>
</div>
